import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Request} from 'express';
import {REQUEST} from '../../../express.tokens';
import {Observable} from 'rxjs';
import {WEBABO_SERVICE_URL} from "./webabo-service-url";

/**
 * Leitet im SSR die relativen HttpClient-Aufrufe an den eigenen Express-Server um. WEBABO_SERVICE_URL ist dabei
 * eine lokale Adresse (127.0.0.1), damit der Pod nicht über den öffentlichen Hostnamen auf sich selbst zugreifen
 * muss. Damit server.ts trotzdem den richtigen vHost findet, wird der Kunden-Host als X-Forwarded-Host
 * mitgeschickt (alle vHost-Lookups in server.ts werten X-Forwarded-Host vor Host aus).
 *
 * Achtung (Finding N-SSR-3): Wird die Auswertung der X-Forwarded-*-Header in server.ts künftig auf vertrauenswürdige
 * Proxies beschränkt, muss Loopback (127.0.0.1/::1) dazugehören, sonst bricht die vHost-Erkennung dieser Aufrufe.
 */
@Injectable()
export class UniversalInterceptor implements HttpInterceptor {
  protected request? = inject<Request>(REQUEST, { optional: true });

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.request) {
      return next.handle(req);
    }

    let newUrl = inject(WEBABO_SERVICE_URL);
    if (!req.url.startsWith('/')) {
      newUrl += '/';
    }
    newUrl += req.url;

    const forwardedHeaders: Record<string, string | undefined> = {
      'v-host-id': this.getHeader('v-host-id'),
      'x-forwarded-host': this.getHeader('x-forwarded-host') ?? this.getHeader('host'),
      // Rate-Limit in server.ts soll weiterhin die IP des Endkunden sehen, nicht 127.0.0.1
      'x-forwarded-for': this.getHeader('x-forwarded-for'),
      'x-forwarded-proto': this.getHeader('x-forwarded-proto') ?? this.request.protocol,
    };

    let headers: HttpHeaders = req.headers;
    for (const [key, value] of Object.entries(forwardedHeaders)) {
      if (value) {
        headers = headers.set(key, value);
      }
    }

    return next.handle(req.clone({url: newUrl, headers}));
  }

  private getHeader(name: string): string | undefined {
    const value = this.request?.headers[name];
    return Array.isArray(value) ? value.join(', ') : value;
  }
}
